import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "openIcon", "closeIcon"]
  static values = { target: String }

  toggle() {
    const targetElement = this.hasContentTarget
      ? this.contentTarget
      : this.hasTargetValue && document.querySelector(this.targetValue)

    if (!targetElement) return

    targetElement.classList.toggle("hidden")

    if (this.hasOpenIconTarget && this.hasCloseIconTarget) {
      const isHidden = targetElement.classList.contains("hidden")
      this.openIconTarget.classList.toggle("hidden", !isHidden)
      this.closeIconTarget.classList.toggle("hidden", isHidden)
    }
  }
}
